import { useState } from "react";
import { guideSteps } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function EntryGuide() {
  const [downloaded, setDownloaded] = useState(false);

  return (
    <section id="guide" className="relative overflow-hidden">
      <div className="pointer-events-none absolute right-0 top-10 h-64 w-64 rounded-full bg-accent-100/60 blur-3xl"></div>
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="不迷路方案"
          title="防走丢的永久入口，从这里开始"
          desc="网址变动、屏蔽来袭都不该让你错过内容。收藏、订阅、下载三件套，加上备用地址，让「吃瓜地址最新发布页」始终触手可及。"
        />

        {/* 醒目入口横幅 */}
        <div className="mt-8 flex flex-col items-start justify-between gap-5 rounded-2xl bg-foreground-950 p-6 text-background-50 md:flex-row md:items-center md:p-8">
          <div className="flex flex-col gap-1.5">
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-300">
              <i className="ri-vip-crown-line"></i>
              推荐 · 最稳的防屏蔽方式
            </span>
            <p className="font-heading text-xl font-bold md:text-2xl">下载吃瓜地址官方 App</p>
            <p className="max-w-md text-sm leading-relaxed text-background-200">
              多线路自动切换 + 新网址推送 + 离线公告，断连时也能第一时间回到社区，彻底告别走丢。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => setDownloaded(true)}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
            >
              <i className={`${downloaded ? "ri-check-line" : "ri-download-2-line"} mr-2 text-lg`}></i>
              {downloaded ? "已开始下载" : "立即下载 App"}
            </button>
            <button
              type="button"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300/40 bg-transparent px-5 py-3 text-sm font-semibold text-background-100 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-qr-code-line mr-2 text-lg"></i>
              扫码获取
            </button>
          </div>
        </div>

        {/* 四步 */}
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((g) => (
            <div
              key={g.title}
              className="group relative overflow-hidden rounded-xl border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300/70"
            >
              <span className="absolute right-4 top-3 font-heading text-3xl font-bold text-secondary-100">
                {g.step}
              </span>
              <span className="relative flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={g.icon}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{g.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}